
export default {
  props: {
    unit: {type: String, default: ''},
    current: {
      type: Number, 
      required: true
    },
    maxlength: {
      type: Number,  
      default: 0
    },
    text_align: {
      type: String,
      default: 'right'
    },
    size: {
      type: String,
      default: '1.4rem'
    },
  },
  computed: {
    counter_text() {
      if (this.unit === 'KB') {
        return `${Math.ceil(this.current * 1000) / 1000}/${this.maxlength} KB`
      }
      return `${this.current}/${this.maxlength} ${this.unit}`.trim()
    },
    my_style () {
      return {
        'text-align': this.text_align,
        'font-size': this.size,
      }
    }
  }
}
